(function stateDefinition() {
    'use strict';
    angular.module('Entities')
        .service('profileCertificateService', [
            'restUrlBuilder', '$injector', '$http', '$q', 'config', function certificateUserService(restUrlBuilder, $injector, $http, $q, config) {
                var restUrlBuilder = restUrlBuilder('auth');


                this.get = function get(ouId, enabled, active , type, typeSign) {

                    var params = { organizationalUnitId: ouId, enabled : enabled , active: active, type: type, signType: typeSign };

                    return restUrlBuilder.all('profilecertificate')
                        .get({ params: params });
                };

            }
        ]);
})();